import { useEffect, useState } from 'react';
import { useAuth } from '../../context/useAuth';
import { useI18n } from '../../context/useI18n';
import GymOrgManageModal from './GymOrgManageModal';

/** Abre el modal de gestión de org al montar (Maestros → Mi marca). */
export default function GymOrgManagePage({ scopeGymId = null, onBack }) {
  const { user } = useAuth();
  const { t } = useI18n();
  const gymId = scopeGymId || user?.gym_id || user?.gymId || user?.tenant_context?.gym_id;
  const [open, setOpen] = useState(true);

  useEffect(() => {
    setOpen(true);
  }, [gymId]);

  if (!gymId) {
    return (
      <div className="dashboard-main-view surface-readable p-6">
        <p className="text-stone-600">{t('gym.mi_marca.no_gym', 'No hay sede asignada a tu cuenta.')}</p>
        {onBack ? (
          <button type="button" className="btn-secondary mt-4" onClick={onBack}>
            {t('common.back', 'Volver')}
          </button>
        ) : null}
      </div>
    );
  }

  return (
    <GymOrgManageModal
      scopeGymId={gymId}
      open={open}
      hideArchive
      onClose={() => {
        setOpen(false);
        onBack?.();
      }}
    />
  );
}
